module.exports = __webpack_public_path__ + "img/hand-point-ribbon.86ce0340.svg";